const popupBanner = {
  $banner: document.querySelector('body > .popup_banner'),
  init() {
    if (this.$banner) {
      const id = this.$banner.dataset.id;
      const userAlreadySeen = localStorage.getItem(`popup_banner_${id}`);

      if (!userAlreadySeen) {
        this.open();
        this.setUpListeners();
      }
    }
  },

  setUpListeners() {
    this.$banner.addEventListener('click', this.handleClick.bind(this));
  },

  handleClick(ev) {
    if (ev.target.closest('.close') || ev.target.classList.contains('popup_banner')) {
      this.close();
    }
  },

  open() {
    this.$banner.classList.add('active');
  },

  close() {
    this.$banner.classList.remove('active');
    localStorage.setItem(`popup_banner_${this.$banner.dataset.id}`, 'true');
  }
};

export default popupBanner;